import React from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon } from 'lucide-react';
import SearchBar from './SearchBar';
interface HeaderProps {
  setSidebarOpen: (open: boolean) => void;
  setSearchResults: (results: any[]) => void;
  setShowSearchResults: (show: boolean) => void;
}
const Header: React.FC<HeaderProps> = ({
  setSidebarOpen,
  setSearchResults,
  setShowSearchResults
}) => {
  return <header className="sticky top-0 z-10 bg-white shadow-sm" data-id="element-63">
      <div className="px-4 sm:px-6 lg:px-8" data-id="element-64">
        <div className="flex items-center justify-between h-16" data-id="element-65">
          <div className="flex items-center" data-id="element-66">
            <button type="button" className="p-2 rounded-md text-gray-400 lg:hidden" onClick={() => setSidebarOpen(true)} data-id="element-67">
              <span className="sr-only" data-id="element-68">Open sidebar</span>
              <MenuIcon className="h-6 w-6" aria-hidden="true" data-id="element-69" />
            </button>
            <Link to="/" className="flex items-center" data-id="element-70">
              <span className="text-xl font-semibold text-gray-900" data-id="element-71">
                PCCN Guidelines
              </span>
            </Link>
          </div>
          <div className="flex-1 flex justify-center px-2 lg:ml-6 lg:justify-end" data-id="element-72">
            <div className="max-w-lg w-full lg:max-w-xs" data-id="element-73">
              <SearchBar setSearchResults={setSearchResults} setShowSearchResults={setShowSearchResults} data-id="element-74" />
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default Header;